module.exports = __webpack_public_path__ + "static/rapid_relief_background-bebb8581e6c6e55a087afb8af7f85b68.png";